export const MenuPresentationTypes = {
  List: 'shop-list',
  Thumb: 'shop-thumb'
};
